/**
 * @flow
 */
import React from 'react';
import { connect } from 'react-redux';
import { Select } from 'semantic-ui-react';
import { range, get } from 'lodash';

const mapStateToProps = (state, props) => {
    let max = 100;
    try {
        if (state.invoice && state.invoice.get) {
            const product = get(
                state.invoice.get('selectedProducts'),
                props.name.replace('quantity', 'entity'),
            );
            if (product) {
                max = product.quantity;
            }
        }
    } catch (e) {
        // Defensive — invoice state may not exist in all contexts
    }
    return { max };
};

const QuantityField = ({ max, meta, dispatch, ...rest }) => {
    // since range doesn't include end, do max + 1
    const options = range(0, (max || 100) + 1).map(item => ({
        value: item,
        text: item,
    }));
    return <Select {...rest} options={options} />;
};

export default connect(mapStateToProps)(QuantityField);
